import api from "utils/api";
import { communityApi } from 'utils/api';

// 메인 공지 베너 목록 조회
export const getMainBannerList = async () => {
    try {
        const res = await api.get(`/buccl_main/api/v1/popups/`);
        return res.data;
    } catch (err) {
        throw err;
    }
};


export const getMainHomeContent = async () => {
    try {
        const res = await api.get(`/buccl_main/api/v1/home/`);
        return res.data;
    } catch (err) {
        throw err;
    }
};

export const getKeywordSearch = async (keyword, signal) => {
  try{
    const res = await api.get('/buccl_main/api/v1/search/', {
      params: { q: keyword.trim() },
      signal,
    });
    return res.data;
  }catch(err){
    throw err;
  }
}

export const getHomeCMSContent = async () => {
  try {
      const res = await api.get(`/buccl_main/api/v1/home-screen/`);
      return res.data;
  } catch (err) {
      throw err;
  }
};


export const getTop5Posting = async () => {
  try {
      const res = await communityApi.get(`/community/api/v1/home/popular`);
      return res.data;
  } catch (err) {
      throw err;
  }
};
